import { Injectable } from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import { environment } from "environments/environment";
import { CookieService } from "ngx-cookie-service";
import { FacebookPixelConsentService } from "./facebook-pixel-consent.service";
import { distinctUntilChanged } from "rxjs";
import { DISABLE_ANALYTICS_COOKIES_COOKIE_KEY } from "app/common";
import { getApiPath } from "app/common";
@Injectable({
  providedIn: "root"
})
export class FacebookPixelService {
  private pixelInitialized = false;

  constructor(
    private router: Router,
    private cookieService: CookieService,
    private consent: FacebookPixelConsentService
  ) {
    if (environment.production && environment.facebookPixelId) {
      this.consent.analyticsConsentChanges$.pipe(distinctUntilChanged()).subscribe((allow) => {
        if (this.cookieService.get(DISABLE_ANALYTICS_COOKIES_COOKIE_KEY) === "false") {
          this.initPixel();
          this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
              if ((window as any).fbq) {
                (window as any).fbq("track", "PageView");
              }
            }
          });
        }
      });
    }
  }

  private getMetaPixelSrc(): string {
    return `${getApiPath()}facebook/fbevents.js`;
  }

  private initPixel(): void {
    if (!this.pixelInitialized) {
      (function (f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
        if (f.fbq) return;
        n = f.fbq = function () {
          // eslint-disable-next-line prefer-spread, prefer-rest-params
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = "2.0";
        n.queue = [];
        t = b.createElement(e);
        t.async = true;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      })(window, document, "script", this.getMetaPixelSrc());

      (window as any).fbq("init", environment.facebookPixelId);
      (window as any).fbq("track", "PageView");

      this.pixelInitialized = true;
    }
  }

  trackEvent(eventName: string, params?: any): void {
    if ((window as any).fbq) {
      (window as any).fbq("track", eventName, params);
    }
  }
}
